export const urlConfig = {
  baseUrl: "https://ai1.4all.cn", //通用平台
  // baseUrl: "https://ai.4all.cn", //唐山业之峰平台
  // baseUrl: "http://localhost:8080/test",
};
